import { useGSAP } from "@gsap/react"
import gsap from "gsap";
import ModelView from "./ModelView";
import { useEffect, useRef, useState } from "react";
import { yellowImg, modelIntroduce, modelIntroduceMB } from "../utils";

import * as THREE from 'three';
import { Canvas } from "@react-three/fiber";
import { View } from "@react-three/drei";
import { models, sizes } from "../constants";
import { animateWithGsapTimeline } from "../utils/animations";

export default function Model({theme, setTheme, isMobile}){
  const [size, setSize] = useState('small');
  const [model, setModel] = useState({
    title: 'iPhone 15 Pro in Natural Titanium',
    color: ['#8F8A81', '#FFE7B9', '#6F6C64'],
    img: yellowImg,
  })

  // camera control for the model view
  const cameraControlSmall = useRef();
  const cameraControlLarge = useRef();

  // model
  const small = useRef(new THREE.Group());
  const large = useRef(new THREE.Group());

  // rotation
  const [smallRotation, setSmallRotation] = useState(0);
  const [largeRotation, setLargeRotation] = useState(0);

  const tl = gsap.timeline();

  useEffect(() => {
    if(size === 'large') {
      animateWithGsapTimeline(tl, small, smallRotation, '#view1', '#view2', {
        transform: 'translateX(-100%)',
        duration: 2
      })
    }

    if(size ==='small') {
      animateWithGsapTimeline(tl, large, largeRotation, '#view2', '#view1', {
        transform: 'translateX(0)',
        duration: 2
      })
    }
  }, [size])

  useGSAP(() => {
    gsap.to('#heading', { y: 0, opacity: 1 })
  }, []);

  return (
    <section id="model" className="p-6 sm:p-16 bg-light">
      {/* <div className="screen-max-width">
        <div className="left-1/2 z-10" style={{position:'absolute',top:'3%',left:'0'}}>
          <p className={`${theme === "dark" ? "hero-title" : "hero-title-light"} text-base md:text-6xl font-bold`} style={{ fontFamily: "Pang" }}>
            产品全貌
          </p>
        </div>
        <div className="flex flex-col items-center mt-5">
          <div className="w-full h-[75vh] md:h-[90vh] overflow-hidden relative">
            <ModelView 
              index={1}
              groupRef={small}
              gsapType="view1"
              controlRef={cameraControlSmall}
              setRotationState={setSmallRotation}
              item={model}
              size={size}
            />  

            <Canvas
              className="w-full h-full"
              style={{
                position: 'fixed',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 0,
                overflow: 'hidden',
                pointerEvents: 'none',
              }}
              eventSource={document.getElementById('root')}
            >
              <View.Port />
            </Canvas>
          </div>
        </div>
      </div> */}
      <div className="w-[100%] rounded-md border-b-[1px] border-r-[1px] border-[#bdc7e9] border-opacity-20 p-6 sm:p-10 shadow-[-2px_-2px_10px_rgba(0,0,0,0.1)] shadow-black/20" style={{backgroundImage:'linear-gradient(to bottom, white,#f3f7ff ,#f2f6ff),linear-gradient(to left, white, #f2f6ff)'}}>
        <div className="screen-max-width py-0 sm:py-6">
          <div className='text-xl sm:text-2xl font-bold mb-6 sm:mb-32 text-[#333333]'>智能警示镜全视图</div>
          <img src={ isMobile?modelIntroduceMB:modelIntroduce } className="mx-auto w-full sm:w-[70%]" alt="" />
        </div>
      </div>
    </section>
  )
}

// export default Model